import { inject } from 'vue';
import { LOCALE } from '../src/constants';
export default () => inject(LOCALE);
